import { Commit } from 'vuex'

import PostApi from '../includes/logic/Api/PostApi'
import { AdminTemplateModuleStore, UserGetMe } from './StoreTypes'

const actions = {
  showSaveConfigButton({ commit }: {commit: Commit}, callback?:() => any): void {
    commit('TOGGLE_SAVE_CONFIG_BUTTON', true)
    if (callback !== undefined) {
      commit('SET_SAVE_CONFIG_BUTTON_CALLBACK', callback)
    }
  },
  hideSaveConfigButton({ commit }: {commit: Commit}): void {
    commit('TOGGLE_SAVE_CONFIG_BUTTON', false)
    commit('RESET_SAVE_CONFIG_BUTTON_CALLBACK')
  },
  async saveAccountData({ state, commit }: { state: AdminTemplateModuleStore, commit: Commit }): Promise<void> {
    if (state.user && state.user.data) {
      const { data } = await PostApi.sendRequest<UserGetMe>('tg', 'setAccountdata', {
        data: { ...state.user.data },
      })
      commit('UPDATE_ACCOUNT_DATA', data.data)
    }
  },
  RELOAD_SIDEBAR_MENU ({ commit }: { commit: Commit}) {
    commit('TOGGLE_MENU_RELOAD')
  }
}

export default actions
